import * as React from 'react'
import { Button, ModalFooter, ModalHeader } from 'reactstrap'
import { SaveButton } from '@hyper/button'
import ModalBody from 'reactstrap/lib/ModalBody'
import { FormProvider, useForm } from 'react-hook-form'
import { RootState, useAppDispatch, useAppSelector } from '@store/index'
import { createReportTask } from '@store/actions/report-tasks-actions'
import { useReportFormRequest } from '@modules/reports/hooks/use-report-request'
import { BaseModalProps } from '@components/modals/types'
import { DateFromToInput } from '@modules/reports/user-reports/common/date-from-to-input'
import { startOfMonth, startOfToday } from 'date-fns'
import { Form } from '@hyper/forms/form'

interface FormInputs {
  canceled_datetime_after: Date | null
  canceled_datetime_before: Date | null
}

export const ReportsMarketingRODOCanceledModal: React.FC<BaseModalProps> = ({ toggleIsVisible }) => {
  const reportUrl = useAppSelector(
    (state: RootState) => state.appState.appData.urls.reports.report_task_marketing_rodo_cancel_report,
  )
  const dispatch = useAppDispatch()

  const methods = useForm<FormInputs>({
    mode: 'all',
    defaultValues: {
      canceled_datetime_after: startOfMonth(startOfToday()),
      canceled_datetime_before: startOfToday(),
    },
  })

  const { isLoading, action: onSubmit } = useReportFormRequest(async (payload: FormInputs) => {
    const reportTask = await dispatch(createReportTask([reportUrl, payload]))
    toggleIsVisible()

    return reportTask
  }, methods.setError)

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ModalHeader toggle={toggleIsVisible}>Raport wycofanych zgód marketingowych (RODO)</ModalHeader>
      <ModalBody>
        <FormProvider {...methods}>
          <DateFromToInput
            label="Data wycofania zgody"
            startDateName="canceled_datetime_after"
            endDateName="canceled_datetime_before"
          />
        </FormProvider>
      </ModalBody>
      <ModalFooter>
        <Button color="light" type="button" onClick={toggleIsVisible}>
          Zamknij
        </Button>
        <SaveButton className="btn btn-green" label="Zleć raport" labelSaving="Zlecanie.." isSaving={isLoading} />
      </ModalFooter>
    </Form>
  )
}
